module.exports = __webpack_public_path__ + "static/media/info-select.a0e6ad27.svg";